import * as React from 'react';
import { Link } from 'react-router-dom';

import { WrappedMessage } from 'utils';
import messages from '../displayMessages';

export interface PartnerProps {
    name: string;
    img: string;
}

interface Props {
    partners: PartnerProps[];
    partnersUrl?: string;
}

export const PartnerSection: React.FunctionComponent<Props> = ({partners, partnersUrl}) => (
    <div className='partner-wrapper'>
        <div className='partner-list'>{partners.map((partner, idx) => {
            return (
                <Partner key={idx} {...partner}/>
            );
        })}</div>
        {partnersUrl ? (
            <Link to={partnersUrl} className='see-all btn btn-outline-primary'>
                <WrappedMessage message={messages.buttonSeeAllPartners}/>
            </Link>
            ) : null
        }
    </div>
);

const Partner: React.FunctionComponent<PartnerProps> = ({name, img}) => (
    <div className='partner'>
        <img src={img} alt={name}/>
    </div>
);
